import { Injectable, Type } from '@angular/core';

import { AnyCardComponent } from '../_shared/models/card/card.model';

import { CardCatalogComponent } from './cards/card-catalog/card-catalog.component';
import { CardIconComponent } from './cards/card-icon/card-icon.component';
import { CardInfoComponent } from './cards/card-info/card-info.component';
import { CardProductComponent } from './cards/card-product/card-product.component';

@Injectable({
    providedIn: 'root',
})
export class CardService {
    private _cards = new Map<string, Type<AnyCardComponent>>([
        ['article', CardInfoComponent],
        ['custom', CardInfoComponent],
        ['icon', CardIconComponent],
        ['info', CardInfoComponent],
        ['catalog', CardCatalogComponent],
        ['product', CardProductComponent],
    ]);

    public addCards(cards: { [type: string]: Type<AnyCardComponent> }[]): void {
        cards.forEach((card) => {
            Object.entries(card).forEach(([type, value]) => {
                if (this._cards.has(type)) {
                    throw new Error(`There already exists a card of the type: ${type}`);
                }
                this._cards.set(type, value);
            });
        });
    }

    public getCard(type: string): Type<AnyCardComponent> | undefined {
        return this._cards.get(type);
    }
}
